import "../styles/globals.scss";
import type { AppProps } from "next/app";
import Script from "next/script";
import { SWRConfig } from "swr";

const SWR_CONFIG = {
  fetcher: (url: string, config: RequestInit) =>
    fetch(url, config).then((r) => r.json()),
};
function MyApp({ Component, pageProps }: AppProps) {
  return (
    <>
      <Script
        async
        strategy="beforeInteractive"
        src="https://www.googletagmanager.com/gtag/js?id=G-R8XXLHR03H"
      />
      <Script strategy="beforeInteractive" id="gtag-script-2" src="/gtag.js" />
      <SWRConfig value={SWR_CONFIG}>
        <Component {...pageProps} />
      </SWRConfig>
    </>
  );
}

export default MyApp;
